import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOrdersCancelParams, TypePostOrdersCancelResponse } from '~/types/delivery-agency.types';

const usePostOrdersCancel = () => {
  const { runAsync } = useAsyncHandler();

  const postOrdersCancel = useAPI<TypePostOrdersCancelParams, TypePostOrdersCancelResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_ORDERS_CANCEL,
    method: 'post',
  });

  const requestOrdersCancel = ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypePostOrdersCancelParams;
    onSuccess?: (data: TypePostOrdersCancelResponse['data']) => void;
    onError?: (error: TypeErrorResponseData['error']) => void;
  }) => {
    return runAsync(() => postOrdersCancel({ params }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestOrdersCancel };
};

export default usePostOrdersCancel;
